module.exports = __webpack_public_path__ + "img/Excelicon.0228c8fb.png";